/* eslint-disable no-unused-vars */
import React, {
  useCallback,
  useRef,
  useState,
  InputHTMLAttributes,
} from "react";

// styles
import styles from "./styles.module.css";

export enum SearchVariant {
  DEFAULT = "DEFAULT",
  SMALL = "SMALL",
}

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSearchClick?: () => void;
  variant?: SearchVariant;
}

const SearchTextInput: React.FC<Props> = ({
  handleChange,
  variant = SearchVariant.DEFAULT,
  ...props
}: Props) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [focused, setFocused] = useState<boolean>(false);

  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>): void => {
      handleChange(e);
    },
    [handleChange]
  );

  return (
    <div
      onClick={() => inputRef?.current?.focus}
      className={`${styles.container} ${
        variant === SearchVariant.SMALL ? styles.small : ""
      }`}
      {...props}>
      <input
        ref={inputRef}
        className={styles.searchInput}
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        {...props}
      />
      {focused && inputRef?.current?.value ? (
        <div></div>
      ) : (
        <div className={styles.image_container}>
          <img src="../../../assets/images/svg/search.svg" />
        </div>
      )}
    </div>
  );
};

export default React.memo(SearchTextInput);
